import { createConfirmation } from "react-confirm";
import ForgotPassModal from "./ForgotPassModal";

export const showForgotPassModal = createConfirmation(ForgotPassModal);
